import { DEFAULT_SESSION_ID } from '../constants';

export const efectorActions = {
  FETCH_EFECTOR_FAILED: 'FETCH_EFECTOR_FAILED',
  FETCH_EFECTOR_SUCCESS: 'FETCH_EFECTOR_SUCCESS',
  FETCH_EFECTOR_PENDING: 'FETCH_EFECTOR_PENDING',
  NAVIGATE_TO_EFECTOR: 'NAVIGATE_TO_EFECTOR',
  LOAD_EFECTOR: 'LOAD_EFECTOR',
  CREATE_EFECTOR:'CREATE_EFECTOR',
  UPDATE_EFECTOR:'UPDATE_EFECTOR',
  DELETE_EFECTOR:'DELETE_EFECTOR',
  RESEND_LOGIN_MAIL: 'RESEND_LOGIN_MAIL',

  fetchEfectorFailed: (error, id) => ({
    type: efectorActions.FETCH_EFECTOR_FAILED,
    payload: {
      error,
      efectorId: id
    }
  }),

  fetchEfectorSuccess: (efectorId, {data}) => ({
    type: efectorActions.FETCH_EFECTOR_SUCCESS,
    payload: {
      efector: data,
      efectorId: ( efectorId === DEFAULT_SESSION_ID && data.id ) ?  data.id : efectorId
    }
  }),

  fetchEfectorPending: efectorId => ({
    type: efectorActions.FETCH_EFECTOR_PENDING,
    payload: {
      efectorId
    }
  }),

  loadEfector: efectorId => ({
    type: efectorActions.LOAD_EFECTOR,
    payload: {
      efectorId: `${efectorId}`
    }
  }),

  createEfector: efector =>({
    type: efectorActions.CREATE_EFECTOR,
    payload: {
      efector,
      efectorId: DEFAULT_SESSION_ID
    }
  }),

  updateEfector: efector =>({
    type: efectorActions.UPDATE_EFECTOR,
    payload: {
      efector,
      efectorId: efector.id
    }
  }),

  deleteEfector: efectorId =>({
    type: efectorActions.DELETE_EFECTOR,
    payload: {
      efectorId
    }
  }),

  loadEfectorByDNI: efectorDNI => ({
    type: efectorActions.LOAD_EFECTOR_BY_DNI,
    payload: {
      efectorDNI
    }
  }),

  navigateToEfector: efectorId => ({
    type: efectorActions.NAVIGATE_TO_EFECTOR,
    payload: {
      pathname: `/efectores/${efectorId}/edit`,
    }
  }),

  resendLoginMail: efectorId => ({
    type: efectorActions.RESEND_LOGIN_MAIL,
    payload: {
        efectorId
    }
  }),
/*
  fetchEfector: filters => {

    return (dispatch, getState) => {

      fetch(api.efector(filters))
      .then((response) => {
            return response.json()
      })
      .then((result) => {

        dispatch({
          type: efectorActions.FETCH_EFECTOR,
          payload: {
           item: result.item,
           filters: filters,
           efectorId: result.item.efectorId,
          }
        })
      })
    }
  },
*/

};


export const efectorRequestActions = {
  failed: efectorActions.fetchEfectorFailed,
  success: efectorActions.fetchEfectorSuccess,
  pending: efectorActions.fetchEfectorPending
};
